<template>
    <div class="m-accordion" :class="{'m-accordion__body-map' : bodyMap}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'accordion',
        props: {
        	bodyMap: {
        		type: Boolean,
        		default: false
        	}
        }
    }
</script>


// WEBPACK FOOTER //
// Accordion.vue?bcc87686